import React from 'react';
import _ from 'lodash';
import { Box, Image, MediaOverlay, Proportion } from '@wix/design-system';
import { MediaSource } from '@wix/ambassador-partners-marketplace-v1-template-listing/types';
import s from '../../TemplateCard.module.scss';

const AnimatedPreviewOverlayContent = ({
  animatedPreview,
}: {
  animatedPreview: MediaSource;
}) => {
  return (
    <Proportion aspectRatio={1}>
      <Box
        height="100%"
        width="100%"
        verticalAlign="middle"
        display="flex"
        align="center"
      >
        <Image
          fit="cover"
          width="100%"
          showBorder={true}
          className={`${s.gif} ${s.gifVisible}`}
          borderRadius="4px"
          transparent
          alt={animatedPreview?.description || 'template image'}
          src={animatedPreview?.url}
        />
      </Box>
    </Proportion>
  );
};

export default AnimatedPreviewOverlayContent;
